<template>
  <input type="text" pattern="[0-9]*" inputmode="numeric" :value="inputValue" @input="handleInput" @blur="formatPrice" @keyup="handleKeyDown"/>
</template>

  <script>
  import EventBus from "@/utils/EventBus";
  import {formatPrice} from "@/utils/utils";

  export default {
    props:{
        index: {
          type: Number,
          default:0,
        },
        nameFunction: {
          type: String,
          default: '',
        },
        roundedNumber:{
          type:Number,
          default:0,
        },
        minNumber:{
          type:Number,
          default:0,
        },
        dataInput: {
          default:''
        }
    },
  data() {
    return {
      inputValue: "",
      previousValue: 0,
    };
  },
  mounted() {
    this.inputValue = this.dataInput
    EventBus.$on("resetInput", () => {
      this.inputValue = this.formatNumber(this.previousValue);
    });
  },
  destroyed(){
    EventBus.$off("resetInput");
  },
  computed: {
    formattedValue() {
      return this.formatNumber(this.value);
    },
  },
  methods: {
    formatPrice(event){
      let parsedValue = this.parseNumber(event.target.value);
      if(this.roundedNumber && this.minNumber){
        parsedValue = this.handleRound(parsedValue, this.minNumber);
        EventBus.$emit(this.nameFunction, parsedValue, this.index);
      }
      return event.target.value = formatPrice(parsedValue);
    },
    formatNumber(number) {
      const formatter = new Intl.NumberFormat("en-US");
      return formatter.format(number);
    },
    parseNumber(value) {
      const parsedValue = value.replace(/[^0-9.]/g, "");
      return parseFloat(parsedValue);
    },
    handleKeyDown(event){
      if (event.key === 'Delete' || event.key === 'Backspace'){
        this.handleInput(event);
      }
    },
    handleInput(event) {
      let parsedValue = this.parseNumber(event.target.value);

      if (!isNaN(parsedValue)) {

        // rounding decimals
        // if(this.roundedNumber){
        //   parsedValue = Math.floor(parsedValue / this.roundedNumber) * this.roundedNumber
        // }console.log(parsedValue)
        this.inputValue = this.formatNumber(parsedValue);
        this.previousValue = parsedValue;
        event.target.value = this.formatNumber(parsedValue);
        EventBus.$emit(this.nameFunction, parsedValue, this.index);
      } else {
        event.target.value = this.formatNumber(0);
        this.inputValue = this.formatNumber(this.previousValue);
      }
    },
    handleRound(number, min){
      if(this.roundedNumber && this.minNumber){
        let value = min + Math.floor((number - min) / this.roundedNumber) * this.roundedNumber;
        return value < min ? min : value;
      }
    }
  },
};
</script>
